import type {
  CreateSchemaInput,
  SchemaListItem,
  SchemaRegistry,
  UpdateSchemaInput,
} from '@morph-mapper/types';
import { api } from '../api';
import type { SchemaListFilters } from '../../types';
import { toListSchemasParams } from './utils';

export const listSchemas = async (
  filters: SchemaListFilters = {},
): Promise<SchemaListItem[]> => {
  const { data } = await api.get<SchemaListItem[]>('/schemas', {
    params: toListSchemasParams(filters),
  });

  return data;
};

export const createSchema = async (
  payload: CreateSchemaInput,
): Promise<SchemaListItem> => {
  const { data } = await api.post<SchemaListItem>('/schemas', payload);

  return data;
};

export const getSchemaById = async (
  schemaId: string,
): Promise<SchemaListItem> => {
  const { data } = await api.get<SchemaListItem>(`/schemas/${schemaId}`);

  return data;
};

export const listSchemaVersions = async (
  schemaId: string,
): Promise<SchemaListItem[]> => {
  const { data } = await api.get<SchemaListItem[]>(
    `/schemas/${schemaId}/versions`,
  );

  return data;
};

export const updateSchema = async (
  schemaId: string,
  payload: UpdateSchemaInput,
): Promise<SchemaListItem> => {
  const { data } = await api.put<SchemaListItem>(
    `/schemas/${schemaId}`,
    payload,
  );

  return data;
};

export const publishSchema = async (
  schemaId: string,
): Promise<SchemaListItem> => {
  const { data } = await api.post<SchemaListItem>(`/schemas/${schemaId}/publish`, {});

  return data;
};

export const draftSchema = async (
  schemaId: string,
): Promise<SchemaListItem> => {
  const { data } = await api.post<SchemaListItem>(`/schemas/${schemaId}/draft`, {});

  return data;
};

export const archiveSchema = async (
  schemaId: string,
): Promise<SchemaListItem> => {
  const { data } = await api.delete<SchemaListItem>(`/schemas/${schemaId}`);

  return data;
};

export const getSchemaRegistry = async (): Promise<SchemaRegistry> => {
  const { data } = await api.get<SchemaRegistry>('/schemas/registry');

  return data;
};
